import { createStyles } from '@mantine/core';

const useStyles = createStyles(
  (
    theme,
    {
      isFullScreen,
      isWide,
    }: {
      isFullScreen: boolean;
      isWide: boolean;
    }
  ) => ({
    container: {
      padding: theme.other.spacing._32,
      paddingTop: theme.other.spacing._24,
      paddingBottom: isWide ? theme.other.spacing._24 : theme.other.spacing._32,
      background: theme.white,
      borderRadius: theme.radius.lg,
      boxShadow: theme.shadows.md,
      display: 'flex',
      flexDirection: isWide ? 'row' : 'column',
      alignItems: 'center',
      justifyContent: isWide ? 'flex-start' : 'center',
      position: 'relative',
      height: isFullScreen ? '100%' : 'auto',
      gap: isWide ? theme.other.spacing._24 : 0,
    },

    closeButton: {
      position: 'absolute',
      top: theme.other.spacing._16,
      right: theme.other.spacing._16,
      backgroundColor: theme.colors.gray[0],
      borderRadius: '100em',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: theme.other.spacing._4,
      cursor: 'pointer',
      transition: 'opacity 150ms ease-in-out',
      zIndex: 1,

      '&:hover': {
        opacity: 0.5,
      },
    },

    header: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    },

    text: {
      marginTop: /* eslint-disable-line local-rules/use-theme-tokens */ isFullScreen ? 20 : theme.other.spacing._12,
      textAlign: isWide ? 'left' : 'center',
      minWidth: 'auto',
    },

    eoBrandContainer: {},

    iconContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: 72,
      height: 72,
      borderRadius: theme.radius.lg,
      border: `2px solid ${theme.colors.gray[2]}`,
    },

    buttons: {
      marginTop: isFullScreen ? theme.other.spacing._40 : theme.other.spacing._24,
      display: 'flex',
      flexDirection: isWide ? 'row' : 'column',
      width: isFullScreen || isWide ? 'auto' : '100%',
      gap: theme.other.spacing._12,
      marginLeft: isWide ? 'auto' : 0,

      '& > button': {
        whiteSpace: 'nowrap',
      },
    },
  })
);

export default useStyles;
